import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFromString',
  pure: false,
  standalone: false,
})
export class DateFromStringPipe implements PipeTransform {
  transform(date: string): any {
    const dateObj = new Date(date);
    const month = dateObj.getUTCMonth() + 1;
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
}
